var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_233_689",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#F5F5F5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_233_689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.8364 15.7197H25.0632V14.8072C25.0632 12.1576 22.9076 10 20.2559 10C17.6042 10 15.4487 12.1556 15.4487 14.8072V15.7197H11.6754C11.3028 15.7197 11 16.0225 11 16.3951V26.3761C11 28.3743 12.6257 30 14.6239 30H25.886C27.8842 30 29.5098 28.3743 29.5098 26.3761V16.3951C29.5098 16.0225 29.207 15.7197 28.8344 15.7197H28.8364ZM16.124 19.2957C16.4966 19.2957 16.7994 18.9929 16.7994 18.6204V17.0704H23.7104V18.6204C23.7104 18.9929 24.0132 19.2957 24.3858 19.2957C24.7583 19.2957 25.0612 18.9929 25.0612 18.6204V17.0704H28.1591V26.3761C28.1591 27.6292 27.1391 28.6493 25.886 28.6493H14.6239C13.3708 28.6493 12.3507 27.6292 12.3507 26.3761V17.0704H15.4487V18.6204C15.4487 18.9929 15.7515 19.2957 16.124 19.2957ZM16.7994 15.7197V14.8072C16.7994 12.9007 18.3493 11.3507 20.2559 11.3507C22.1625 11.3507 23.7124 12.9007 23.7124 14.8072V15.7197H16.8014H16.7994Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBag);
export default __webpack_public_path__ + "static/media/icon_bag.bc1d405ff2c5ea5d46570702ee003751.svg";
export { ForwardRef as ReactComponent };